import React, { forwardRef } from 'react';

import { TemplateNumberFormatInput } from '../../../Components';

const PesoInput = forwardRef((props, ref) => (
  <TemplateNumberFormatInput {...props} escala={1} sufixo=" °C" ref={ref} />
));

export default PesoInput;
